export default "__VITE_ASSET__CmXzUNy0__"